const actions = {
  FETCH_NEWS: 'news/FETCH_NEWS',
}

export default actions
